var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBootstrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 448 448",
    style: {
      enableBackground: "new 0 0 448 448"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.8,179.5c0-17.6-12.4-27.3-34.3-27.3h-40.2V209h33.9C245.4,208.8,259.8,198.3,259.8,179.5z M406,169.3 c-7.6-24.6-8.7-54.8-7.8-78.2c0.9-24.3-18.1-46.6-43.6-46.6H92.6C67,44.5,48.1,66.9,49,91.1c0.8,23.4-0.2,53.6-7.8,78.2 c-7.6,24.7-20.5,40.3-41.6,42.3v22.7c21,2,34,17.6,41.6,42.3c7.6,24.6,8.7,54.8,7.8,78.2c-0.9,24.3,18.1,46.6,43.6,46.6h262 c25.6,0,44.5-22.4,43.6-46.6c-0.8-23.4,0.2-53.6,7.8-78.2c7.7-24.7,20.5-40.3,41.5-42.3v-22.7C426.5,209.6,413.7,194,406,169.3z  M233.2,318h-78V128h77.6c34.5,0,57.2,18.7,57.2,47.4c0,20.2-15.2,38.2-34.7,41.3v1c26.5,2.9,44.2,21.2,44.2,46.5 C299.5,297.8,274.7,318,233.2,318z M225.4,231.3h-39.9v62.5h41.7c27.3,0,41.7-10.9,41.7-31.5C268.8,241.9,253.9,231.3,225.4,231.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.e7ba29a6d24f6884a4b8591eec14eedf.svg";
export { ForwardRef as ReactComponent };